"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_CHANGE = exports.SORT_CHANGE = exports.FILTER_CHANGE = exports.PAGINATION_CHANGE = void 0;
exports.PAGINATION_CHANGE = 'PAGINATION_CHANGE';
exports.FILTER_CHANGE = 'FILTER_CHANGE';
exports.SORT_CHANGE = 'SORT_CHANGE';
exports.SEARCH_CHANGE = 'SEARCH_CHANGE';
//# sourceMappingURL=ManipulationTypes.js.map